import PropTypes from "prop-types";
import ImageHelper from '../../../../../../../../utilities/helpers/ImageHelper';
import logo from '../../../../../../../../assets/images/experience_balnk.svg';
import { UseCurrencyDecorator } from "../../../../../../../../utilities/hooks/UseCurrencyDecorator";
import { AmountFormatHelper } from "../../../../../../../../utilities/helpers/AmountFormatHelper";
import moment from "moment";
import { useDictionary } from "../../../../../../../../utilities/hooks/UseDictionary";

const CustomerBookingItem = ({booking,onBookingClicked}) => {
    const currencyDecorator = UseCurrencyDecorator();
    const dictionary = useDictionary();

    const getDate = (date) => {
        if(date) {
            return moment(date* 1000).format('MMM DD, YYYY')
        }
    }
    return (
        <tr
			className="slot-booking-container"
			key={booking.id}
			onClick={() => onBookingClicked(booking)}
		>
            <td>
                <div className="booking-number">
                    {booking.display_id}
                </div>
            </td>
            <td>
                <div className="d-flex-center custom-experience-container">
                    <div className="custom-experience-image-container">
                        <img
                            onError={(e) => {
                                e.currentTarget.src = logo;
                            }}
                            src={booking?.thumbnail_url ? ImageHelper.getFullImageUrl(booking?.thumbnail_url) : logo}
                            className="custom-experience-image"
                        />
                    </div>
                    <div className="custom-experience-title truncate" title={booking?.experience_title}>
                        {booking?.experience_title}
                    </div>
                </div>
            </td>
            <td>
                <div className="customer-details-field">
                    {(booking.participants_quantity ? (booking.participants_quantity > 1 ? (`${booking.participants_quantity} ${dictionary.seats}`) : (`${booking.participants_quantity} ${dictionary.seat}`)) : 0 )}
                </div>
            </td>
            <td>
                <div className="customer-details-field">
                    {getDate(booking.start_date)}
                </div>
            </td>
            <td>
                <div className="customer-details-field">
                    {currencyDecorator(AmountFormatHelper.formatAmount(booking.amount), booking.currency)}
                </div>
            </td>
        </tr>
    )
            
}

CustomerBookingItem.propTypes = {
  booking: PropTypes.object,
  onBookingClicked: PropTypes.func
};

export default CustomerBookingItem;